module.exports = "/images/project-deliverable-green.svg?f54dd2e3701981789d61d4cfce237728";